<template>
  <base-modal :show-close="false" :center="true" :visible.sync="visible"
              :modal-width="popupInfo && popupInfo?.modalWidth ? popupInfo?.modalWidth :'70%'"
              type="custom">
    <div v-if="popupInfo?.type === 2" class="privacy-modal">
      <div class="privacy-modal-header">
        <h3 class="header-title">{{popupInfo?.title}}</h3>
      </div>
      <div class="privacy-modal-content">
        皇家加勒比集团始终重视并致力于保护您的个人信息，为帮助您了解关于个人信息处理方式的更多详细信息，{{popupInfo?.changeNote}}您可以点击<a :href="privacyLink" target="_blank" class="privacy-link">
        《隐私政策》</a>以完整阅读更新后的内容，当您点击【同意并继续】时，即表示您已理解并同意该条款内容。
      </div>
      <div class="privacy-modal-footer">
        <button class="btn cancle" @click="cancelAgree">退出</button>
        <button class="btn is-agree" @click="submitAgree">同意并继续</button>
      </div>
    </div>
    <div v-else-if="popupInfo?.type === 3" class="privacy-modal type-3">
      <div class="privacy-modal-header type-3">
        <div class="header-title">{{popupInfo?.title}}</div>
        <div class="header-close" @click="closeAgree">
          <img class="icon" :src="`${imgUrl}/global/icons/iconCloseWhite.png`" alt="" />
        </div>
      </div>
      <div class="privacy-modal-content type-3">
        为持续完善会员服务机制，我们更新了《皇家游享荟项目细则》，{{popupInfo?.changeNote}}您可点击<a :href="rewardPrivacyLink" class="privacy-link">链接</a>了解具体内容，并仔细阅读。您也可咨询客服电话（4008207705）或在线客服。
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'
const VUE_APP_OFFICIAL_URL=process.env.VUE_APP_OFFICIAL_URL
export default {
  name: "PrivacyModal",
  components: {BaseModal},
  props: {
    value: {
      type: Boolean,
    },
    userAgreementInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        if(val === false) this.closeAgree();
        this.$emit("update:value", val)
      }

    }
  },
  watch: {
    value(val) {
      if(val) {
        const {type, changeNote} = this.userAgreementInfo;
        // 1:用户协议 2:隐私政策 3:皇家游享荟项目细则
        const popupInfoVal = {
          2: {
            title: "《隐私政策》更新提醒",
            modalWidth: 650,
            changeNote: changeNote,
            type: type
          },
          3: {
            title: "温馨提示",
            modalWidth: 560,
            changeNote: changeNote,
            type: type
          }
        }
        this.popupInfo = popupInfoVal[type];
      }
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      privacyLink: VUE_APP_OFFICIAL_URL + "/Rccl.UserCenter/Privacy",
      userAgreementLink: VUE_APP_OFFICIAL_URL + "/wz_index_law/index",
      rewardPrivacyLink: VUE_APP_OFFICIAL_URL + "/Rccl.UserCenter/RewardRule",
      popupInfo: null
    }
  },
  methods: {
    cancelAgree() {
      this.$emit('submit',{ isAgree: false, type: this.userAgreementInfo.type });
    },
    submitAgree() {
      this.$emit('submit',{ isAgree: true, type: this.userAgreementInfo.type });
    },
    closeAgree() {
      this.submitAgree();
    }
  }
}
</script>

<style lang="less" scoped>
.privacy-modal {
  padding: 30px 30px;
  &.type-3 {
    padding: 0 0;
    border-radius: 16px;
  }
}

.privacy-modal-header {
  font-size: 32px;
  text-align: center;
  & .header-title {
    color: #333333;
  }
  & .header-close {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    border-radius: 40px;
    background-color: rgba(136,136,136,0.5);
    & .icon {
      height: 24px;
      width: 24px;
    }
  }
  &.type-3 {
    margin: 0 20px;
    border-bottom: 1px solid #eee;
    & .header-title {
      padding: 16px 0 12px;
      line-height: 44px;
      color: #FCC000;
    }
  }
}

.privacy-modal-content {
  text-indent: 2em;
  line-height: 1.6;
  color: #333333;
  font-size: 24px;
  margin-top: 20px;
  max-height: 260px;
  overflow-x: hidden;
  overflow-y: auto;
  & .privacy-link {
    color: #006AB6;
    text-decoration: underline;
  }
  &.type-3 {
    font-size: 28px;
    text-indent: 0;
    min-height: 150px;
    max-height: 260rpx;
    padding: 0 30px 30px;
  }
}

.privacy-modal-footer {
  display: flex;
  justify-content: center;
  margin-top: 50px;

  & .btn {
    font-size: 24px;
    color: #333333;
    border: 1px solid #cccccc;
    background-color: #FFFFFF;
    padding: 10px 0;
    width: 160px;
    border-radius: 5px;
    box-sizing: border-box;
    &.cancle{
      padding: 10px 0;
    }

    &:hover {
      background-color: #F0F0F0;
    }

    &:active {
      background-color: #f7f7f7;
    }

    &.is-agree {
      margin-left: 20px;
      border: 1px solid #FBC500;
      background-color: #FBC500;

      &:hover {
        background-color: #daaa09;
      }

      &:active {
        background-color: #FBC500;
      }
    }
  }
}
</style>